import * as React from 'react';
import RouteNotYetImplemented from 'views/NotYetImplemented';

export default () => {
  return <RouteNotYetImplemented routeName={'Mentorias'} />;
};
